import React from 'react';
import BoxContainerBase from './BoxContainer';

function BoxContainer(props) {
  return <BoxContainerBase {...props} />;
}

export default BoxContainer;
